module.exports = __webpack_public_path__ + "static/iheart-5019db57318c895474ae4f5a9ed70de3.png";